






import AbpBase from "@/lib/abpbase"
import {Component, Prop} from "vue-property-decorator"
import {GetPatEducations} from "@/api/propaganda"

@Component({
	components:{}
})
export default class PatientInfo extends AbpBase {
	@Prop() patient: any
	loading = false
	tableData = []
	columns=[
		{
			title: '宣教库标题',
			key: 'resourceTitle'
		},
		{
			title: '医护人员',
			key: 'docName'
		},
		{
			title: '宣教日期',
			key: 'eduDate'
		},
		{
			title: '教育对象',
			key: 'eduObject'
		},
		{
			title: '宣教方式',
			key: 'eduType'
		},
		{
			title: '宣教评价',
			key: 'eduEvaluate'
		},
		{
			title: '宣教地点',
			key: 'eduPlace'
		}
	]
	created(){
		this.getData()
	}

	private async getData() {
		this.loading = true
		let res = await GetPatEducations({PatientId:this.patient.id})
		this.tableData = res.objects
		this.loading = false
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/electronicMedicalRecord/patient/parts/missionInformation/index.vue